import {
  declareFont,
  defineFont,
  fontStyles,
  fontWeights,
  Font,
  declareFontPreload,
} from '../utils/FontUtils'

enum FontKeys {
  // Monument grotesk
  MonumentGroteskRegular = 'MonumentGroteskRegular',
  MonumentGroteskMedium = 'MonumentGroteskMedium',
}

export const declarations: { [key in FontKeys]: Font } = {
  MonumentGroteskRegular: {
    basename: 'MonumentGroteskRegular',
    fontFamily: 'MonumentGrotesk',
    fontWeight: fontWeights.regular,
    fontStyle: fontStyles.normal,
    fallback: 'sans-serif',
  },
  MonumentGroteskMedium: {
    basename: 'MonumentGroteskMedium',
    fontFamily: 'MonumentGrotesk',
    fontWeight: fontWeights.medium,
    fontStyle: fontStyles.normal,
    fallback: 'sans-serif',
  },
}

export const fontsFaces = (): string =>
  Object.values(declarations)
    .filter((font) => !font.isAlreadyDeclared && font)
    .map(declareFont)
    .join(' ')

const fonts: { [key in FontKeys]?: string } = {
  MonumentGroteskRegular: defineFont(declarations.MonumentGroteskRegular),
  MonumentGroteskMedium: defineFont(declarations.MonumentGroteskMedium),
}

export const fontsPreload = () =>
  Object.values(declarations)
    .filter((font) => !font.isAlreadyDeclared && font)
    .map(declareFontPreload)

export default fonts
